import { jsx as _jsx } from "react/jsx-runtime";
import { Text as DSText } from "@cinch-labs/design-system";
import cx from "classnames";
import styles from "./text.module.css";
export var Text = function(param) {
    var children = param.children, className = param.className;
    return /*#__PURE__*/ _jsx(DSText, {
        element: "p",
        className: cx(styles.root, className),
        children: children
    });
};
